export const handleValidation = (item, e) => {
  if (item.type === "UUID") {
    let value = e.target.value;

    // convert to lowercase and remove special characters
    value = value.toLowerCase().replace(/[^a-z0-9]/g, "");

    e.target.value = value;
  }

  return e;
};